import { pxToRem } from '../../../../lib';

var commonButtonsStyles = function commonButtonsStyles(circular) {
  return circular ? {
    marginRight: pxToRem(8)
  } : {
    borderRadius: 0
  };
};

var buttonGroupStyles = {
  root: function root() {
    return {};
  },
  middleButton: function middleButton(_ref) {
    var p = _ref.props;
    return Object.assign({}, commonButtonsStyles(p.circular));
  },
  firstButton: function firstButton(_ref2) {
    var p = _ref2.props,
        v = _ref2.variables;
    return Object.assign({}, commonButtonsStyles(p.circular), !p.circular && {
      borderTopLeftRadius: v.borderRadius,
      borderBottomLeftRadius: v.borderRadius
    });
  },
  lastButton: function lastButton(_ref3) {
    var p = _ref3.props,
        v = _ref3.variables;
    return Object.assign({}, commonButtonsStyles(p.circular), !p.circular && {
      borderTopRightRadius: v.borderRadius,
      borderBottomRightRadius: v.borderRadius
    });
  }
};
export default buttonGroupStyles;